var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-1 pr-4",staticStyle:{"min-width":"0"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',{staticStyle:{"font-family":"Inter","font-size":"0.875rem","font-weight":"400","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","display":"block"}},[_vm._v(" "+_vm._s(_vm.alert?.url || _vm.url)+" ")])])]),_c('v-col',{staticClass:"py-1",staticStyle:{"flex-shrink":"0"},attrs:{"cols":"auto"}},[_c('span',{style:({
        color: _vm.statusColor,
        fontFamily: 'Inter',
        fontSize: '0.875rem',
        fontWeight: '600',
        whiteSpace: 'nowrap',
      })},[_vm._v(" "+_vm._s(_vm.connectsValue)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }